import { Navigate, useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, [navigate]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/" />;
};
